type Environment = 'staging' | 'production' | 'uat';

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

interface EnvironmentConfig {
  firebase: FirebaseConfig;
  cloudFunctions: {
    baseURL: string;
  };
  cloudRunServices: {
    projectNumber: string;
    graphqlUrl: string;
    realtimeWsUrl: string;
    realtimeEnabled: boolean;
  };
}

const realtimeEnabled = import.meta.env.VITE_REMI_REALTIME_ENABLED === 'true';
const realtimeWsUrlOverride = import.meta.env.VITE_REMI_REALTIME_WS_URL;

const uatConfig: EnvironmentConfig = {
  firebase: {
    apiKey: 'AIzaSyAoRc4W7QJKpWOBg-Wvs23VyLf-EfzJOj8',
    authDomain: 'speculo-uat.firebaseapp.com',
    projectId: 'speculo-uat',
    storageBucket: 'speculo-uat.firebasestorage.app',
    messagingSenderId: '845225729852',
    appId: '1:845225729852:web:45649415080bdcd4d1c839',
    measurementId: 'G-F0BEW1KEZ6',
  },
  cloudFunctions: {
    baseURL: 'https://us-central1-speculo-uat.cloudfunctions.net',
  },
  cloudRunServices: {
    projectNumber: '845225729852',
    graphqlUrl: 'https://remi-api-845225729852.us-central1.run.app/graphql',
    realtimeWsUrl: realtimeWsUrlOverride || 'wss://remi-realtime-845225729852.us-central1.run.app',
    realtimeEnabled,
  },
};

const stagingConfig: EnvironmentConfig = {
  firebase: {
    apiKey: 'AIzaSyCCTovTXros2NLNbON26jpfkcX3fyxngL0',
    authDomain: 'speculo-staging.firebaseapp.com',
    projectId: 'speculo-staging',
    storageBucket: 'speculo-staging.firebasestorage.app',
    messagingSenderId: '70707136872',
    appId: '1:70707136872:web:03165f1c55f1ad00b0eedd',
    measurementId: 'G-PF7K09MR13',
  },
  cloudFunctions: {
    baseURL: 'https://us-central1-speculo-staging.cloudfunctions.net',
  },
  cloudRunServices: {
    projectNumber: '70707136872',
    graphqlUrl: 'https://remi-api-70707136872.us-central1.run.app/graphql',
    realtimeWsUrl: realtimeWsUrlOverride || 'wss://remi-realtime-70707136872.us-central1.run.app',
    realtimeEnabled,
  },
};

const productionConfig: EnvironmentConfig = {
  firebase: {
    apiKey: 'AIzaSyDVuZ1z3umUXPErCuEYox3se0LbHhEYjhI',
    authDomain: 'heyisaai.firebaseapp.com',
    projectId: 'heyisaai',
    storageBucket: 'heyisaai.appspot.com',
    messagingSenderId: '54875993561',
    appId: '1:54875993561:web:55d04f09a41667f99495c8',
    measurementId: 'G-51HE24K2Q5',
  },
  cloudFunctions: {
    baseURL: 'https://us-central1-heyisaai.cloudfunctions.net',
  },
  cloudRunServices: {
    projectNumber: '54875993561',
    graphqlUrl: 'https://remi-api-54875993561.us-central1.run.app/graphql',
    realtimeWsUrl: realtimeWsUrlOverride || 'wss://remi-realtime-54875993561.us-central1.run.app',
    realtimeEnabled,
  },
};

// Environment can be set via environment variable or build-time configuration
const currentEnvironment: Environment = (import.meta.env.VITE_APP_ENV || 'staging') as Environment;

export const getConfig = () => {
  switch (currentEnvironment) {
    case 'production':
      return productionConfig;
    case 'uat':
      return uatConfig;
    default:
      return stagingConfig;
  }
};

export const isProduction = () => currentEnvironment === 'production';
export const isStaging = () => currentEnvironment === 'staging';
export const isUat = () => currentEnvironment === 'uat';
